import { noop } from 'lodash';
import React, { Component } from 'react';

import Announcer, { Announce } from './Announcer';
import AnnouncerContext from './AnnouncerContext';

export default class AnnouncerProvider extends Component {
  private announceImpl: Announce = noop;

  public render() {
    return (
      <>
        <AnnouncerContext.Provider value={{ announce: this.announce }}>{this.props.children}</AnnouncerContext.Provider>
        <Announcer announceRef={this.setAnnounce} />
      </>
    );
  }

  private readonly setAnnounce = (value: Announce) => {
    this.announceImpl = value;
  };

  private readonly announce = (text: string) => {
    this.announceImpl(text);
  };
}
